// extracted by mini-css-extract-plugin
module.exports = {"buffer":"styles_buffer__ZbXME","root":"styles_root__CL2Tb","close-button":"styles_close-button__G-jd7"};